let environment: null | Object = null;
function getEnvironment() {
  if (!environment) {
    environment = {
      UA: window.navigator.userAgent,
      // window.environment // TODO 确定环境信息
    };
  }
  return environment;
}
const lxFn = {
  pageView(cid, valLab = {}, env = {}) {
    const newEnv = { ...getEnvironment(), ...env };
    window.LXAnalytics && window.LXAnalytics('pageView', valLab, newEnv, cid);
  },
  moduleView(valBid, valLab = {}, options = null) {
    window.LXAnalytics && window.LXAnalytics('moduleView', valBid, valLab, options);
  },
  moduleClick(valBid, valLab = {}, options = null) {
    window.LXAnalytics && window.LXAnalytics('moduleClick', valBid, valLab, options);
  },
};

export default lxFn;
